import React, { useState } from 'react';
import NoteContent from '../../../components/Notes/NoteContent';

const NotesSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="card" id="posts-section">
      <div className="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">
        <h6 className="tx-uppercase tx-semibold mg-b-0">Notes</h6>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? 'Hide' : 'Show'} Notes
        </button>
      </div>
      {isExpanded && (
        <div className="card-body pd-25">
          <NoteContent open={true} />
        </div>
      )}
    </div>
  );
};

export default NotesSection;
